<template>
  <div style="">
    <div class="sub-nav-box">
      <!-- judul halaman -->
      <h2>Inventaris</h2>
      <!-- sub menu halaman -->
      <div class="sub-nav-menu">
        <p
          style="width: unset"
          ref="Asset"
          @click="changeView('Asset')"
          class="sub-nav-lembur-title active"
        >
          Asset
        </p>
        <p ref="Bhp" @click="changeView('Bhp')">BHP</p>
      </div>
      <!-- end of sub menu halaman -->
    </div>

    <!-- main view halaman -->
    <div style="background: none" class="main-view">
      <component :is="view"></component>
    </div>
    <!-- end of main view halaman -->
  </div>
</template>

<script>
import Asset from "@/components/finance/inventaris/Asset";
import Bhp from "@/components/finance/inventaris/Bhp";

export default {
  components: {
    Asset,
    Bhp ,
  },

  data() {
    return {
      // current component / current sub page
      view: "Asset",
    };
  },

  methods: {
    // ganti component/ sub page
    changeView(view) {
      // non-active nav
      let currentNav = this.$refs[this.view];
      currentNav.classList.remove("active");
      // active nav
      this.view = view;
      let nextNav = this.$refs[this.view];
      nextNav.classList.add("active");
    },
  },
};
</script>
